// extracted by mini-css-extract-plugin
export default {"text":"dyYUmP","avatar":"ZjaLSN","action":"Zm5q5Z"};